module.exports = __webpack_public_path__ + "media/images/redrock/pending-backdrop-582a9b03dafe11182a950247b1e9f2a2.jpeg";